<template>
  <div class="customer-detail">
    <div class="customer-header pt-0">
      <slot name="header"></slot>

      <div class="text-xs-center">
        <v-avatar size="100">
          <v-img
            :lazy-src="user.profile_pic"
            :src="user.profile_pic"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template #placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </v-avatar>
        <div class="text-xs-center mt-2" style="color: white">
          {{ user.first_name ? user.first_name : '' }} {{ user.last_name ? user.last_name : '' }}
        </div>
        <div class="mb-4 text-xs-center">
          <v-btn
            v-if="user.app == 'facebook' && user.inboxurl"
            :href="'https://business.facebook.com/latest/' + user.userid"
            target="_blank"
            small
            depressed
            round
            color="#3b5998"
            dark
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('View inbox') }}
          </v-btn>
        </div>
      </div>
    </div>
    <template v-if="!loading">
      <div v-if="selectedBot.theme == 'sahapan'" class="text-xs-right">
        <sahapan-add-manual :user="user"></sahapan-add-manual>
      </div>
      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Channel') }}</label>
          <p>
            <span v-if="user.app == 'facebook'" style="color: #3b5998">
              <em class="fab fa-facebook-square" /> Facebook
            </span>
            <span v-else-if="user.app == 'line'" style="color: #00c300">
              <em class="fab fa-line" /> Line
            </span>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Locale') }}</label>
          <p>
            <template v-if="userLocale">
              <flag :iso="userLocale.icon" />
              {{ userLocale.title }}
            </template>
            <template v-else>-</template>
          </p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption">
            {{ $t('Status') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>
          <div>
            <p>
              <edit-customer-value
                v-model="user['status']"
                :userid="user.id"
                :placeholder="$t('Status')"
                @onEdit="onEditStatus"
              >
                <customer-item-value :value="user['status']">{{ user.status }}</customer-item-value>
              </edit-customer-value>
            </p>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('ชื่อจริง') }}</label>
          <p>{{ $t(user.realname) }}</p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('อาชีพ') }}</label>
          <p>{{ $t(user.position) }}</p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('สถานที่ปรึกษา') }}</label>
          <p>{{ $t(user.education) }}</p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption">
            {{ $t('Address') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>
          <div>
            <p>
              <edit-customer-value
                v-model="user['address']"
                :userid="user.id"
                :placeholder="$t('Address')"
                @onEdit="onEditAddress"
              >
                <customer-item-value :value="user['address']">{{
                  user.address
                }}</customer-item-value>
              </edit-customer-value>
            </p>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('No. of consult') }}</label>
          <p>{{ user.tags ? user.tags.split(',').length : '0' }}</p>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Register Date') }}</label>
          <p>
            {{ user.registertimestamp ? getFormatDate(user.registertimestamp, 'DD/MM/YYYY') : '-' }}
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Last Active Date') }}</label>
          <p>{{ user.timestamp ? getFormatDate(user.timestamp, 'DD/MM/YYYY') : '-' }}</p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Email') }}</label>
          <p>
            <edit-customer-value
              v-model="user['email']"
              :userid="user.id"
              :placeholder="$t('Email')"
              @onEdit="onEditEmail"
            >
              <customer-item-value :value="user['email']">{{ user.email }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('phone no.') }}</label>
          <p>
            <edit-customer-value
              v-model="user['phoneno']"
              :userid="user.id"
              :placeholder="$t('phone no.')"
              @onEdit="onEditPhone"
            >
              <customer-item-value :value="user['phoneno']">{{ user.phoneno }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Context') }}</label>
          <p>
            <edit-customer-value
              v-model="user['context']"
              :userid="user.id"
              :placeholder="$t('Context')"
              @onEdit="onEditContext"
            >
              <customer-item-value :value="user['context']">{{ user.context }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Line ID') }}</label>
          <p>
            <edit-customer-value
              v-model="user['lineid']"
              :userid="user.id"
              :placeholder="$t('Line ID')"
              @onEdit="onEditLineId"
            >
              <customer-item-value :value="user['lineid']">{{ user.lineid }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('School') }}</label>
          <p>
            <edit-customer-school
              v-model="user['school']"
              :userid="user.id"
              :placeholder="$t('School')"
              @onEdit="onEditSchool"
            >
              <customer-item-value :value="user['school']">{{ user.school }}</customer-item-value>
            </edit-customer-school>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Province') }}</label>
          <p>
            <edit-customer-value
              v-model="user['province']"
              :userid="user.id"
              :placeholder="$t('Province')"
              @onEdit="onEditProvince"
            >
              <customer-item-value :value="user['province']">{{
                user.province
              }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
      </v-layout>

      <v-layout v-if="selectedBot.theme == 'sahapan'" wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Real First Name') }}</label>
          <p>
            <edit-customer-value
              v-model="user['realfirstname']"
              :userid="user.id"
              :placeholder="$t('Real First Name')"
              @onEdit="saveSahapanUserProfile('realfirstname', $event)"
            >
              <customer-item-value :value="user['realfirstname']">{{
                user.realfirstname
              }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Real Last Name') }}</label>
          <p>
            <edit-customer-value
              v-model="user['reallastname']"
              :userid="user.id"
              :placeholder="$t('Real Last Name')"
              @onEdit="saveSahapanUserProfile('reallastname', $event)"
            >
              <customer-item-value :value="user['reallastname']">{{
                user.reallastname
              }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Date of Birth') }}</label>
          <p>
            <edit-customer-value
              v-model="user['dob']"
              :userid="user.id"
              :placeholder="$t('Date of Birth')"
              type="date"
              @onEdit="saveSahapanUserProfile('dob', $event)"
            >
              <customer-item-value :value="user['dob']">
                <template v-if="user.dob">{{ user.dob | DateFormat('DD/MM/YYYY') }}</template>
                <template v-else>-</template>
              </customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
        <v-flex xs12 sm6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Address') }}</label>
          <p>
            <edit-customer-value
              v-model="user['address']"
              :userid="user.id"
              :placeholder="$t('Address')"
              @onEdit="saveSahapanUserProfile('address', $event)"
            >
              <customer-item-value :value="user['address']">{{ user.address }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <div class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>
          {{ $t('Tag') }}
          <v-premium-lock :inline="true"></v-premium-lock>
        </label>

        <a
          v-if="$store.getters.getPackage == 'premium' && !isEditTag && !isCoachlab"
          href="javascript:void(0);"
          @click="editTag"
        >
          <em class="fa fa-pencil-alt middle" />
        </a>
      </div>
      <div class="pl-3 pr-3 pt-2 pb-2">
        <template v-if="!isEditTag">
          <div v-if="tags.length == 0" class="text-xs-left">{{ $t('No tag') }}</div>
          <ul class="tags">
            <li v-for="(tag, index) in tags" :key="'usertag_' + index" class="tag">
              <specialtext :text="tag"></specialtext>
            </li>
          </ul>
        </template>
        <template v-else>
          <tags
            v-model="usertag"
            :tags="usertags"
            style="margin-bottom: 5px"
            :btn-text="$t('Add tag')"
            @tags-changed="addUserTags"
            @before-adding-tag="checkUserTags"
          ></tags>

          <div class="text-xs-center" style="margin-top: 15px">
            <v-btn outline color="grey" small @click="cancelEditTag">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" small @click="saveEditTag">{{ $t('Save') }}</v-btn>
          </div>
        </template>
      </div>

      <v-divider></v-divider>

      <div class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('Message Sent') }}</label>
        <div style="position: relative" margin-top="25">
          <v-premium-plan-popup
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
            :show-all="false"
          ></v-premium-plan-popup>
          <div
            style="
              overflow-y: auto;
              max-height: 300px;
              padding: 5px;
              background: #f7f7f7;
              border: 1px solid #eee;
              border-radius: 5px;
            "
          >
            <template v-if="$store.getters.getPackage != 'premium' || isCoachlab">
              <div
                v-for="(intent, index) in 10"
                :key="'intent_' + index"
                style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
              >
                <div
                  style="
                    height: 15px;
                    position: relative;
                    top: 3px;
                    display: inline-block;
                    width: 100%;
                    max-width: 100px;
                    background-color: #eee;
                  "
                ></div>
              </div>
            </template>
            <template v-else>
              <template v-if="filterIntent.length > 0">
                <div
                  v-for="(intent, index) in filterIntent"
                  :key="'intent_' + index"
                  style="padding: 10px; margin: 5px 0; border: 1px solid #eee; background: white"
                >
                  <template v-if="$store.getters.getPackage == 'premium' && !isCoachlab">
                    {{ intentLabel(intent[0]) }}
                    ({{ intent[1] | numberFormat }})
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="text-center">{{ $t('No message sent') }}</div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import CustomerItemValue from '../../customer/CustomerItemValue'
import EditCustomerValue from './../../EditCustomerValue'
import EditCustomerSchool from './../../EditCustomerSchool'
import specialtext from '@/components/elements/specialtext'
import Tags from '@/components/elements/Tags'
import SahapanAddManual from '../../customize/sahapan/SahapanAddManual.vue'
import api from '@/api'

export default {
  components: {
    CustomerItemValue,
    EditCustomerValue,
    EditCustomerSchool,
    specialtext,
    SahapanAddManual,
    Tags
  },
  props: {
    value: {
      default: undefined
    }
  },
  data: function () {
    return {
      sahapandialog: true,
      loading: true,
      user: {},
      isEditTag: false,
      usertag: '',
      profile_pic: '',
      saveloading: false,
      toauser: {
        paysolutionmerchantid: '',
        fillgood_token: '',
        shop_id: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filterIntent: function () {
      var vm = this
      return vm.user.intentlist.sort(function (a, b) {
        if (parseInt(a[1]) > parseInt(b[1])) {
          return -1
        }

        if (parseInt(a[1]) < parseInt(b[1])) {
          return 1
        }

        return 0
      })
    },
    userLocale: function () {
      var vm = this
      return config.locale.find(function (locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function () {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function (tag) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag) {
            result.push(tag.text)
          })
        }
        vm.user.tags = result.join(',')
      }
    }
  },
  watch: {
    // value: function() {
    //   this.user = this.value
    // }
  },
  mounted: function () {
    this.getuserDetail()
    // this.user = this.value
    // this.cached_tag = this.user.tags
  },
  methods: {
    editTag() {
      this.isEditTag = true
      this.cached_tag = JSON.parse(JSON.stringify(this.user.tags))
    },
    saveSahapanUserProfile(type, payload) {
      var vm = this
      this.$set(this.user, type, payload.customer_value)
      vm.$store.dispatch('loading')
      var data = {
        lineid: this.user.id,
        firstname: this.user.realfirstname,
        lastname: this.user.reallastname,
        gender: this.user.gender,
        address: this.user.address,
        dob: this.user.dob ? moment(this.user.dob).format() : moment().format(),
        phoneno: this.user.phoneno,
        email: this.user.email
      }
      api.saveSahapanUserProfile(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.$forceUpdate()
      })
    },
    getuserDetail() {
      let vm = this
      let data = { pageid: vm.selectedBot.pageid, userid: vm.value }
      api.getuserCustomer(data, function (error, response) {
        if (error) console.error(error)
        vm.user = response.data[0]
        var realname = response.data[0].realname ? response.data[0].realname.split(' ') : ''
        vm.user.realfirstname = realname.length > 0 ? realname[0] : ''
        vm.user.reallastname = realname.length > 1 ? realname[1] : ''
        vm.user.dob = vm.user.dob
          ? moment(vm.user.dob).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD')
        if (vm.selectedBot.theme == 'toa') {
          Object.assign(vm.user, JSON.parse(vm.user.json_variable))
        }
        vm.loading = false
      })
    },
    onEditAddress(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        address: payload.customer_value
      }
      api.saveUserAddress(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditContext(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        context: payload.customer_value
      }
      api.saveUserContext(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    saveEditTag: function () {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        usersid: vm.user.id,
        tags: vm.user.tags
      }
      api.saveUserTags(data, function (error) {
        if (error) {
          console.error(error)
        }
        vm.cached_tag = vm.user.tags
        vm.isEditTag = false
      })
    },
    cancelEditTag: function () {
      this.user.tags = this.cached_tag
      this.isEditTag = false
    },
    onFailLoad: function () {
      this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    addUserTags: function (newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 25) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onEditStatus: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        status: payload.customer_value
      }
      api.saveUserStatus(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditLineId: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        lineid: payload.customer_value
      }
      api.saveUserLineId(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditSchool: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        school: payload.customer_value
      }
      api.saveUserSchool(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditProvince: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        province: payload.customer_value
      }
      api.saveUserProvince(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditEmail: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        email: payload.customer_value
      }
      api.saveUserEmail(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditPhone: function (payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        phoneno: payload.customer_value
      }
      api.saveUserPhoneno(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/ramapoison/RamapoisonCustomerDetail.vue